/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { Grid, makeStyles } from '@material-ui/core';
import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useFormState, useForm } from 'react-final-form';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import {
  fetchMetadadosModelo,
  fetchAllOrgaosAnuentes,
} from "../../features/lpco/lpcoMicroApi"

import LpcoDynamicFields from '../lpco-dynamic-fields/LpcoDynamicFields';

import OrgaosAnuentesField from './components/OrgaosAnuentesField';
import ModelosLpcosOrgaoField from './components/ModelosLpcosOrgaoField';
import QCXLicencaImportacaoBasicasFormLPCOStepWizard from './QCXLicencaImportacaoBasicasFormLPCOStepWizard';

const useStyles = makeStyles((theme) => ({
  gridFields: {
    paddingBottom: '16px',
  },
  checkboxGridField: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '16px',
    },
    paddingBottom: '16px',
  },
}));

export default function QCXLicencaImportacaoBasicasFormLPCO({
  initialValues,
  handleSubmit,
  isConsult,
  isLocked,
  controlComponentProps,
  ...restProps
}) {


  const listenerList = [
    {
      name: 'atributosAdicionais.modalidadeDrawback',
      fn: () => null,
    },
  ];

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onChangeListeners={listenerList}
      controlComponentProps={controlComponentProps}
      disablePristine
      {...restProps}
    >
      {({ values, form }) => (
          <QCXLicencaImportacaoBasicasFormLPCOStepWizard
            values={values}
            isConsult={isConsult}
            isLocked={isLocked}
          />
      )}
    </QCXFormStepWizard>
  );
}
